import "./App.scss";
import Archive from "./components/Archive";
import AuthFacade from "./facade/auth.Facade";
import Layout from "./components/common/Layout";
import LandingPage from "./components/landingpage";
import React, { Suspense, useEffect } from "react";
import Settings from "./components/settings/Settings";
import ProjectDetails from "./components/ProjectDetails";
import { useAppDispatch, useAppSelector } from "./store/hooks/StoreHooks";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import NoAccess from "./components/common/noaccess/NoAccess";
import "@fontsource/mulish";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CalculationHelper from "./components/CalculationHelper";
import NoProjectAccess from "./components/common/noaccess/NoProjectAccess";
import Documents from "./components/documents";
import EquipmentCatalog from "./components/equipment-catalog";

const ProtectedRoute = () => {
  const { user, userLoading } = useAppSelector((state) => state?.auth);
  if (!user?.userRole?.includes("Admin")) {
    return <NoProjectAccess message={!userLoading ? "You do not have access to this page. Please contact administrator or" : ""} />;
  }

  return <Outlet />;
};

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn, user, error } = useAppSelector((state) => state.auth);
  const { tokenLogin, validateLogin, getUser, startRefreshToken, clearTokenInterval } = AuthFacade();
  useEffect(() => {
    if (window.location.href.indexOf("?ref=") > 0) {
      let reference = window.location.href.split("ref=").pop()?.toString();
      if (reference !== undefined) {
        tokenLogin(reference);
      }
    } else {
      validateLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn) {
      getUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  useEffect(() => {
    const refreshTokenAsync = () => {
      startRefreshToken();
    };
    refreshTokenAsync();
    return () => {
      clearTokenInterval();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startRefreshToken]);

  return (
    <>
      <ToastContainer />
      {!isLoggedIn && (error?.includes("403") || error?.includes("404")) ? (
        <NoAccess />
      ) : (
        isLoggedIn && (
          <Suspense fallback={<div>Loading...</div>}>
            <Router>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route path="/no-project-access" element={<NoProjectAccess message="You do not have access to this Project. Please contact administrator or" />} />
                  <Route path="/dashboard" Component={LandingPage} />
                  <Route path="/archive" Component={Archive} />
                  <Route path="/settings" Component={Settings} />
                  <Route
                    path="/project-details/:ID"
                    Component={ProjectDetails}
                  />
                  <Route
                    path={`/project-details/:ID/:caseID/`}
                    Component={ProjectDetails}
                  />
                  <Route
                    path="/help"
                    Component={CalculationHelper}
                  />
                  <Route
                    path="/documents"
                    Component={Documents}
                  />
                  <Route element={<ProtectedRoute />}>
                    <Route path="/equipment-catalog" Component={EquipmentCatalog} />
                  </Route>
                  <Route
                    path="/"
                    element={<Navigate to="/dashboard" replace />}
                  />
                </Route>
              </Routes>
            </Router>
          </Suspense>
        )
      )}
    </>
  );
};

export default App;
